import { lazy, Suspense, type ReactElement } from "react";
import { useSearchParams } from "wouter";
import { EventLanding } from "./EventLanding";
import {
  defaultEvent,
  defaultRedirect,
  EVENT,
  isValidEvent,
  isValidRedirect,
} from "./eventsConstants";
import { NoEvent } from "./NoEvent";

const DevOpsConTwentyFive = lazy(() =>
  import("./giveaways/DevOpsConTwentyFive").then((module) => ({
    default: module.DevOpsConTwentyFive,
  })),
);
const KubeCloudNativeCon25 = lazy(() =>
  import("./giveaways/KubeCloudNativeCon25").then((module) => ({
    default: module.KubeCloudNativeCon25,
  })),
);

const useQueryEventKeys = () => {
  const [params] = useSearchParams();
  const urlEvent = params.get("id");
  const urlRedirect = params.get("redirect");
  return {
    event: isValidEvent(urlEvent) ? urlEvent : defaultEvent,
    redirect: isValidRedirect(urlRedirect) ? urlRedirect : defaultRedirect,
  };
};

const eventComponentMap = {
  [EVENT.NONE]: NoEvent,
  [EVENT.HOME]: EventLanding,
  [EVENT.DEVOPSCON2025]: DevOpsConTwentyFive,
  [EVENT.KUBECNCON2025]: KubeCloudNativeCon25,
};

export default function EventHome(): ReactElement {
  const { event, redirect } = useQueryEventKeys();

  let EventComponent;
  if (event) {
    // This block will always have an event in the QS of the url
    EventComponent = event
      ? eventComponentMap[event]
      : eventComponentMap[EVENT.NONE];
  } else {
    // Note: This is a home page
    EventComponent = eventComponentMap[EVENT.HOME];
  }

  return (
    <Suspense fallback={null}>
      <EventComponent
        eventName={event ?? defaultEvent}
        event={event ?? defaultEvent}
        redirect={redirect ?? defaultRedirect}
      />
    </Suspense>
  );
}
